import React from 'react';

import { createReactRenderer } from 'helpers/react-renderer';

import { AmountDueInput } from './components/AmountDueInput';
import { PaymentDueDateInput } from './components/PaymentDueDateInput';
import PaymentTermsContainer from './components/PaymentTermsContainer';
import { PaymentTermsContextProvider } from './contexts/CreditStatementTermsContext';
import { CreditAccountConstantProps, CreditAccountDynamicProps } from './types';

export type CreditAccountStatementProps = {
  constantProps: CreditAccountConstantProps;
  dynamicProps: CreditAccountDynamicProps;
};

const CreditAccountStatement = ({ constantProps, dynamicProps }: CreditAccountStatementProps) => {
  return (
    <PaymentTermsContextProvider constantProps={constantProps} dynamicProps={dynamicProps}>
      <PaymentDueDateInput />
      <AmountDueInput />
      <PaymentTermsContainer />
    </PaymentTermsContextProvider>
  );
};

const RenderedComponent = createReactRenderer({
  component: CreditAccountStatement,
  selector: '[data-react-root="CreditACStatement"]',
});

export default CreditAccountStatement;

history.onChangeState(
  [
    {
      name: ['customer.views.customer'],
      form_name: 'view',
      tab: 'account',
      id: undefined,
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
